// extracted by mini-css-extract-plugin
module.exports = {"companySelect":"CompanyPage_companySelect__1kbHo","tabWithCounter":"CompanyPage_tabWithCounter__3sT3v","countBadge":"CompanyPage_countBadge__2zaZe"};